import createIcon from '../../createIcon';

/**
 * @component @name CameraEnhance
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOSAzTDcuMTcgNUg0QzIuOSA1IDIgNS45IDIgN1YxOUMyIDIwLjEgMi45IDIxIDQgMjFIMjBDMjEuMSAyMSAyMiAyMC4xIDIyIDE5VjdDMjIgNS45IDIxLjEgNSAyMCA1SDE2LjgzTDE1IDNIOVpNMTIgMThDOS4yNCAxOCA3IDE1Ljc2IDcgMTNDNyAxMC4yNCA5LjI0IDggMTIgOEMxNC43NiA4IDE3IDEwLjI0IDE3IDEzQzE3IDE1Ljc2IDE0Ljc2IDE4IDEyIDE4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEyIDE3TDEzLjI1IDE0LjI1TDE2IDEzTDEzLjI1IDExLjc1TDEyIDlMMTAuNzUgMTEuNzVMOCAxM0wxMC43NSAxNC4yNUwxMiAxN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraEnhance = createIcon('CameraEnhance', [
  [
    'path',
    {
      d: 'M9 3L7.17 5H4C2.9 5 2 5.9 2 7V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V7C22 5.9 21.1 5 20 5H16.83L15 3H9ZM12 18C9.24 18 7 15.76 7 13C7 10.24 9.24 8 12 8C14.76 8 17 10.24 17 13C17 15.76 14.76 18 12 18Z',
      key: '12qgg3',
    },
  ],
  [
    'path',
    {
      d: 'M12 17L13.25 14.25L16 13L13.25 11.75L12 9L10.75 11.75L8 13L10.75 14.25L12 17Z',
      key: '1a37or',
    },
  ],
]);

export default CameraEnhance;
